import { render, staticRenderFns } from "./OrgExists.vue?vue&type=template&id=19752bc3&"
import script from "./OrgExists.vue?vue&type=script&lang=js&"
export * from "./OrgExists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports